<div class="snackbar" #snakbar>{{ message }}</div>
